import React, { useEffect, useState } from 'react';
import { ImagePath } from '../../common/ImagePath';
import { useNavigate } from 'react-router-dom';
import { ApiService } from '../../utils/ApiService';
import { showToast } from '../../common/Toast';
import {Mail,EyeIcon,EyeClosed} from 'lucide-react'
import toast from 'react-hot-toast';
const Login = ({ }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState({});
    const navigate = useNavigate()

    const validate = ()=>{
        let newError ={}
          const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if(!email){
              newError.email = 'Email is required'
            }else if (!emailRegex.test(email)) {
                newError.email = 'Invalid email address'
            }
        if(!password){
            newError.password = 'Password is required'
        }
        setError(newError)      
        return Object.keys(newError).length === 0
    }
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            if(!validate()) return;

            if (email && password) {
                const res = await ApiService.post("login", {
                    email: email,
                    password: password,
                    userRole:'ADMIN'
                })
                console.log(res)
                if(res.success){
                    localStorage.setItem('auth_token', res.token)
                    localStorage.setItem('refresh_token', res.refreshToken)
                    toast.success("Logged In Successfully")
                    navigate('/dashboard')
                }
            }
        } catch (error) {
            console.log("Error while Admin Login --> ", error)
            // toast.error("Invalid Credentials")
        }
    };

    useEffect(() => {
        if (localStorage.getItem('auth_token')) {
            navigate('/dashboard')
        }
    }, [])

    return (
        <div className="min-h-screen flex justify-center items-center bg-cream-bg relative overflow-hidden">

            {/* Background Shapes: Absolute positioning */}
            <img
                src={ImagePath.topLeftLogin}
                alt="Top Left Background Accent"
                className="absolute top-0 left-0 w-[350px] lg:w-[450px] z-10 opacity-90"
            />
            <img
                src={ImagePath.bottomRightLogin}
                alt="Bottom Right Background Accent"
                className="absolute bottom-0 right-0 w-[400px] lg:w-[500px] z-10 opacity-90"
            />

            {/* Main Centered Content 
                *** MODIFIED: Replaced max-w-lg with responsive width classes ***
            */}
            <div className="w-11/12 md:w-1/2 lg:w-2/5 xl:w-[50vw] p-4 text-center z-20">

                {/* Logo Section */}
                <header className="mb-8">
                    <img src={ImagePath.logo} alt="Let's Gather Logo" className="mx-auto max-w-[262px] mb-1" />
                </header>

                {/* Welcome Text */}
                <main className="mb-10">
                    <h2 className="text-4xl font-semibold text-black mb-3">
                        Welcome to Let's Gather Admin
                    </h2>
                    {/* The p tag's max-w-lg is fine for readability */}
                    <span className="text-lg text-base font-semibold text-[#4C4C4C] max-w-lg mx-auto leading-relaxed">
                    Manage events, hosts, attendees, and transactions — all from one secure dashboard.
                    </span>
                </main>

                {/* Login Form Card */}
                <section className="bg-white p-10 rounded-3xl shadow-card max-w-[678px] mx-auto">
                    <form onSubmit={handleSubmit} noValidate>

                        {/* Email Input Group */}
                        <div className="mb-6 text-left">
                            <label htmlFor="email" className="block text-black font-semibold mb-2">
                                Email Id
                            </label>
                            <div className="relative">
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="Enter your email id"
                                    value={email}
                                    onChange={(e) => {setEmail(e.target.value)
                                        setError((prev)=>{
                                            return {...prev,email:''}})
                                    }}
                                    required
                                    maxLength={30}
                                    className="w-full p-3 pl-4 pr-10 border border-input-border rounded-xl text-dark-brown focus:border-primary-brown focus:ring-primary-brown focus:outline-none transition-colors"
                                />
                                <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-gray">
                                    <Mail />
                                </span>
                            </div>
                                {error.email &&<p className='text-red-500 text-sm mt-1'>{error.email}</p>}
                        </div>

                        {/* Password Input Group */}
                        <div className="mb-8 text-left">
                            <label htmlFor="password" className="block text-black font-semibold mb-2">
                                Password
                            </label>
                            <div className="relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => {setPassword(e.target.value)
                                        setError((prev)=>{
                                            return {...prev,password:''}
                                        })
                                    }}
                                    maxLength={30}
                                    required
                                    className="w-full p-3 pl-4 pr-10 border border-input-border rounded-lg text-dark-brown focus:border-primary-brown focus:ring-primary-brown focus:outline-none transition-colors"
                                />
                                <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-gray">
                                {showPassword ? (
                                    <EyeClosed onClick={() => setShowPassword(!showPassword)} />
                                ) : (
                                    <EyeIcon onClick={() => setShowPassword(!showPassword)} />
                                )}
                                </span>
                            </div>
                                 {error.password && <p className='text-red-500 text-sm mt-1'>{error.password}</p>}
                        </div>

                        {/* Login Button */}
                        <button
                            type="submit"
                            className="w-full mt-4 py-2 bg-[#8B7355] text-white font-semibold rounded-lg text-lg hover:shadow-lg transition-colors"
                        >
                            Login
                        </button>
                    </form>
                </section>
            </div>
        </div>
    );
};

export default Login;